import React from 'react';
import { IconCloseChip } from '../../../components/buttons/IconButtons';
import CustomTooltip from '../../../components/CustomTooltip';
import {
    getGateFolioDescription,
    getGateFolioInitials,
    getGateFolioName,
} from '../Model/Model';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Folio the gate picked out of the search, read with what it is opened for.
 *
 * The card names the folio the same way the option it was picked from does, and
 * says the direction it moves its materials in and the status it is read with
 * at the gate.
 *
 * @param {Object} folio Folio the gate picked.
 * @param {Function} onRemove Leaves the folio so another one is looked for.
 * @returns {JSX.Element}
 */
const SelectedFolioCard = ({
    folio,
    onRemove,
}) => {
    const description = getGateFolioDescription(folio);

    return (
        <div
            className='d-flex align-items-center gap-12px w-100 mt-16px p-12px background-primary-25 border-full-primary-100 border-radius-16px'>
            <span
                className='d-flex flex-shrink-0 align-items-center justify-content-center w-44px h-44px background-general-00 border-radius-12px fs-14px ibl-font-w-700 font-color-primary-800'>
                {getGateFolioInitials(folio?.code)}
            </span>

            <div className='flex-grow-1 minw-0'>
                {/* The request the folio was captured with is as long as the gate
                    wrote it, so the name is read in a single row and the whole
                    of it is read in the tooltip when it does not fit */}
                <CustomTooltip
                    text={getGateFolioName(folio)}
                    classes='fs-14px ibl-font-w-700 font-color-primary-800 text-ellipsis-1-row'
                    showIfTruncated={true}
                />

                {description &&
                    <p className='mb-0 fs-13px ibl-font-w-400 font-color-primary-700 word-break'>{description}</p>}
            </div>

            <div>
                <IconCloseChip
                    className='icon-color-shades-400'
                    onClick={onRemove}
                />
            </div>

        </div>
    );
};

export default SelectedFolioCard;
